export default __webpack_public_path__ + "static/media/010-dj mixer.07439ec1.svg";